import type { SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "VIONA",
    tagline: "UPVC windows, doors and conservatories",
    description: "VIONA designs and installs energy-efficient UPVC windows, doors and conservatories, made to measure for your home. Book a free survey and get a clear, fixed quote.",
    url: getOrigin(),
    ogImage: 'https://viona.cdn.modulify.website/site/hero.jpg',
    // Leave a field empty to hide it everywhere. Filled fields appear in the
    // header, footer and contact page automatically.
    contact: {
        phone: "",
        email: "",
        address: "",
        hours: ""
    }
}
